import moment from 'moment';

/** Earliest bookable start time on most weekdays. */
export const DEFAULT_FIRST_START = '9:00 AM';
/** Earliest bookable start time on Thursdays. */
export const THURSDAY_FIRST_START = '1:00 PM';
/** Latest bookable start time (tours and event starts). */
export const LAST_START = '7:00 PM';
/** Latest visible / selectable end time for events. */
export const LAST_END = '8:00 PM';

/**
 * Business-hour windows for a given calendar day.
 * Shared by homepage Calendar Preview and tour/event DateTime steps.
 */
export const getBookingHourWindows = (year, month, day) => {
  const selectedDate = moment({
    year,
    month: month - 1,
    date: day,
  });
  const isThursday = selectedDate.format('dddd') === 'Thursday';
  const firstStartTime = moment(
    isThursday ? THURSDAY_FIRST_START : DEFAULT_FIRST_START,
    'h:mm A',
  );
  const lastStartTime = moment(LAST_START, 'h:mm A');
  const lastEndTime = moment(LAST_END, 'h:mm A');

  return {
    isThursday,
    firstStartTime,
    lastStartTime,
    lastEndTime,
  };
};

const toMoment = timeLabel => moment(timeLabel, 'h:mm A');

/** Slot can be chosen as a tour start or an event start. */
export const isWithinStartWindow = (timeLabel, windows) => {
  const timeMoment = toMoment(timeLabel);
  return (
    timeMoment.isSameOrAfter(windows.firstStartTime) &&
    timeMoment.isSameOrBefore(windows.lastStartTime)
  );
};

/** Slot can be chosen as an event end time. */
export const isWithinEndWindow = (timeLabel, windows) => {
  const timeMoment = toMoment(timeLabel);
  return (
    timeMoment.isSameOrAfter(windows.firstStartTime) &&
    timeMoment.isSameOrBefore(windows.lastEndTime)
  );
};

/**
 * Whether a slot should appear in the grid at all.
 * - tour / preview: start window only (through 7:00 PM)
 * - event: through last end (8:00 PM) so end times remain visible
 */
export const shouldDisplayTimeSlot = (timeLabel, windows, mode = 'tour') => {
  const timeMoment = toMoment(timeLabel);
  if (timeMoment.isBefore(windows.firstStartTime)) {
    return false;
  }
  if (mode === 'event') {
    return timeMoment.isSameOrBefore(windows.lastEndTime);
  }
  return timeMoment.isSameOrBefore(windows.lastStartTime);
};
